import { HttpStatusCode } from '../http-status-code';
import { PejError } from './pej-error';

export class PejHttpError extends PejError {
  constructor(
    public readonly statusCode: HttpStatusCode,
    message: string,
    details?: Record<string, any>,
  ) {
    super(message, details);
    Object.setPrototypeOf(this, PejHttpError.prototype);
    this.name = this.constructor.name;
  }
}
